import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { Topic } from '../topic'
import { Project } from '../project'

@Component({
  selector: 'app-assigned-topic-box',
  templateUrl: './assigned-topic-box.component.html',
  styleUrls: ['./assigned-topic-box.component.css']
})
export class AssignedTopicBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  @Input() topic: Topic
  @Input() project: Project
  isDeleteMode = false

  constructor() { }

  ngOnInit() {
  }

  deleteAssignement() {
    this.isDeleteMode = !this.isDeleteMode
  }

  confirmDeleteAssignement() {
    this.project.deleteDbRecordTopic(this.dbRecord, this.topic)
  }

}



// WEBPACK FOOTER //
// ./src/app/assigned-topic-box/assigned-topic-box.component.ts